
import { Button, Card, Heading, Row, Stack, Text } from '@client/shared/design';
import { formatCalendarDate } from '@client/shared/lib/wall-clock-intake.ts';
import type { CreatedListing } from './new-listing-mutation.ts';
import styles from './NewListing.module.css';

export function CreatedSummary({ listing, onDone }: { listing: CreatedListing; onDone?: () => void }) {
  return (
    <Card pad="lg" spine raised className={styles.successCard} as="section">
      <Stack gap={5} align="start">
        <span className={styles.successMark} aria-hidden="true">
          <BigCheck />
        </span>

        <Stack gap={2}>
          <Heading level={2}>Listing created.</Heading>
          <Text tone="soft">
            Agents can now book open houses at this property within the booking window you set.
          </Text>
        </Stack>

        <Stack gap={2} className={styles.successFacts}>
          <Row gap={2} align="baseline" wrap>
            <Text size="sm" tone="muted" className={styles.factLabel}>
              Address
            </Text>
            <Text weight="medium">{listing.formattedAddress ?? '-'}</Text>
          </Row>
          <Row gap={2} align="baseline" wrap>
            <Text size="sm" tone="muted" className={styles.factLabel}>
              Booking window
            </Text>
            <Text weight="medium" className={styles.mono}>
              {listing.bookingUntil
                ? `Through ${formatCalendarDate(listing.bookingUntil)}`
                : `${listing.bookingHorizonDays ?? '-'} days ahead`}
            </Text>
          </Row>
        </Stack>

        <Row gap={3}>
          {onDone && (
            <Button variant="primary" onClick={onDone}>
              Done
            </Button>
          )}
        </Row>
      </Stack>
    </Card>
  );
}

function BigCheck() {
  return (
    <svg width="30" height="30" viewBox="0 0 32 32" fill="none" aria-hidden="true">
      <circle cx="16" cy="16" r="15" fill="currentColor" opacity="0.14" />
      <path
        d="M9 16.5l4.5 4.5L23 11"
        stroke="currentColor"
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
